export default "__VITE_ASSET__cdccb1c9__"